import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { MemberSearch } from '@/components/shared/search/MemberSearch';

interface AddChildRequestDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { childName: string; parentId: string; phoneNumber: string }) => void;
}

export function AddChildRequestDialog({
  open,
  onClose,
  onSubmit,
}: AddChildRequestDialogProps) {
  const [childName, setChildName] = useState('');
  const [parentId, setParentId] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const handleSubmit = () => {
    if (!childName.trim() || !parentId || !phoneNumber.trim()) return;
    onSubmit({ 
      childName: childName.trim(), 
      parentId,
      phoneNumber: phoneNumber.trim()
    });
    setChildName('');
    setParentId('');
    setPhoneNumber('');
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>طلب إضافة مولود</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="childName">اسم المولود</Label>
            <Input
              id="childName"
              value={childName}
              onChange={(e) => setChildName(e.target.value)}
              placeholder="أدخل اسم المولود"
            />
          </div>

          <div className="space-y-2">
            <Label>الأب</Label>
            <MemberSearch
              onSelect={setParentId}
              placeholder="ابحث عن الأب..."
              className="w-full"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="phoneNumber">رقم الجوال</Label>
            <Input
              id="phoneNumber"
              type="tel"
              dir="ltr"
              className="text-left"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="05xxxxxxxx"
            />
          </div>
        </div>
        <DialogFooter className="sm:justify-start">
          <Button
            onClick={handleSubmit}
            disabled={!childName.trim() || !parentId || !phoneNumber.trim()}
            className="hover:bg-secondary"
          >
            إرسال الطلب
          </Button>
          <Button
            variant="ghost"
            onClick={onClose}
            className="mr-2"
          >
            إلغاء
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}